import { render, staticRenderFns } from "./GoBackButton.vue?vue&type=template&id=71d4b709&scoped=true&"
import script from "./GoBackButton.vue?vue&type=script&lang=ts&"
export * from "./GoBackButton.vue?vue&type=script&lang=ts&"
import style0 from "./GoBackButton.vue?vue&type=style&index=0&id=71d4b709&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d4b709",
  null
  
)

export default component.exports